export function validateNew(values) {
  let errors = {};

  if (!values.first_name) {
    errors.first_name = "First Name is required";
  } else if (!/^[A-Za-z]+$/.test(values.first_name)) {
    errors.first_name = "First Name is invalid";
  }

  if (!values.last_name) {
    errors.last_name = "Last Name is required";
  } else if (!/^[A-Za-z]+$/.test(values.last_name)) {
    errors.last_name = "Last Name is invalid";
  }

  if (!values.user_name) {
    errors.user_name = "Username is required";
  } else if (!/^[A-Za-z0-9]+$/.test(values.user_name)) {
    errors.user_name = "Last Name is invalid";
  }

  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password.length < 6) {
    errors.password = "Password must have at least 6 characters";
  } else if (values.password.length > 16) {
    errors.password = "Password must have less than 16 characters";
  }

  if (!values.email) {
    errors.email = "Email address is required";
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = "Email address is invalid";
  }

  if (!values.phone_number) {
    errors.phone_number = "Phone number is required";
  } else if (!/^[0-9]+$/.test(values.phone_number)) {
    errors.phone_number = "Phone Number is invalid";
  }

  if (!values.mobile_number) {
    errors.mobile_number = "Mobile number is required";
  } else if (!/^[0-9]+$/.test(values.mobile_number)) {
    errors.mobile_number = "Mobile Number is invalid";
  }

  if (!values.gender) {
    errors.gender = "Gender is required";
  }

  if (!values.deleted) {
    errors.deleted = "Status is required";
  }

  return errors;
}

export function validateEdit(values) {
  let errors = {};

  if (!values.first_name) {
    errors.first_name = "First Name is required";
  } else if (!/^[A-Za-z]+$/.test(values.first_name)) {
    errors.first_name = "First Name is invalid";
  }

  if (!values.last_name) {
    errors.last_name = "Last Name is required";
  } else if (!/^[A-Za-z]+$/.test(values.last_name)) {
    errors.last_name = "Last Name is invalid";
  }

  if (!values.user_name) {
    errors.user_name = "Username is required";
  } else if (!/^[A-Za-z0-9]+$/.test(values.user_name)) {
    errors.user_name = "Last Name is invalid";
  }

  if (!values.email) {
    errors.email = "Email address is required";
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = "Email address is invalid";
  }

  if (!values.phone_number) {
    errors.phone_number = "Phone number is required";
  } else if (!/^[0-9]+$/.test(values.phone_number)) {
    errors.phone_number = "Phone Number is invalid";
  }

  if (!values.mobile_number) {
    errors.mobile_number = "Mobile number is required";
  } else if (!/^[0-9]+$/.test(values.mobile_number)) {
    errors.mobile_number = "Mobile Number is invalid";
  }

  if (!values.gender) {
    errors.gender = "Gender is required";
  }

  if (typeof values.deleted === "boolean") {
    if (!values.deleted.toString()) {
      errors.deleted = "Status is required";
    }
  } else if (typeof values.deleted === "string") {
    if (!values.deleted) {
      errors.deleted = "Status is required";
    }
  }

  return errors;
}

